import { render } from "./AdminDoughnutChart.vue?vue&type=template&id=d349dd94&scoped=true"
import script from "./AdminDoughnutChart.vue?vue&type=script&lang=js"
export * from "./AdminDoughnutChart.vue?vue&type=script&lang=js"

import "./AdminDoughnutChart.vue?vue&type=style&index=0&id=d349dd94&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d349dd94"]])

export default __exports__